import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';
import merchantTermsAndConditions from './merchantTermsAndConditions';
import { setMerchantTermsAndConditionsPdfFormInterface } from './merchantTermsAndConditions';
import merchantTraining from './merchantTraining';
import { setMerchantTrainingPdfFormInterface } from './merchantTraining';

export default (axios: AxiosInstance = baseAxios): { merchantTermsAndConditions: { fetchMerchantTermsAndConditionsPdf: () => Promise<{ pdfUrl: string; }>; setMerchantTermsAndConditionsPdf: (form: setMerchantTermsAndConditionsPdfFormInterface) => Promise<void>; }; merchantTraining: { fetchMerchantTrainingPdf: () => Promise<{ pdfUrl: string; }>; setMerchantTrainingPdf: (form: setMerchantTrainingPdfFormInterface) => Promise<void>; }; } => ({
    merchantTermsAndConditions: merchantTermsAndConditions(axios),
    merchantTraining: merchantTraining(axios),
});
